.container {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
  background-color: var(--color-bg-subtle);
  user-select: none;
}

.canvas {
  position: absolute;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.empty {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  color: var(--color-text-muted);
}
